var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }, [
      _c("div", {
        staticClass:
          "md-layout-item md-size-15 md-small-size-100 md-xsmall-size-100"
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-70 md-small-size-100 md-xsmall-size-100"
        },
        [
          _c(
            "md-card",
            [
              _c("md-card-header", [
                _c("div", { staticClass: "md-title" }, [
                  _vm._v("Benutzerkonto aktivieren")
                ])
              ]),
              _vm._v(" "),
              _c(
                "md-card-content",
                [
                  _vm.sending
                    ? _c("md-progress-spinner", {
                        attrs: {
                          "md-diameter": 30,
                          "md-stroke": 3,
                          "md-mode": "indeterminate"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.sending && !_vm.sent
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-primary md-raised",
                          on: {
                            click: function($event) {
                              return _vm.activate()
                            }
                          }
                        },
                        [_vm._v("Benutzerkonto aktivieren")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.error
                    ? _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          "Tut uns Leid, aber der angegebene Aktivierungslink ist uns nicht\n            bekannt."
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-15 md-small-size-100 md-xsmall-size-100"
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f6b18e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f6b18e1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/authentication/signup/activate/Activate.vue
// module id = null
// module chunks = 